import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
// Whenever a user clicks the "Sign Up" button
export const SignUp_Begin = BaseAnalyticsEvent.extend({
    name: z.literal("SignUp_Begin"),
    properties: z.object({
        source: z.string().optional()
    })
});
export const DemoRequest_Begin = BaseAnalyticsEvent.extend({
    name: z.literal("DemoRequest_Begin"),
    properties: z.object({
        source: z.string().optional()
    })
});
export const DemoRequest_Visit = BaseAnalyticsEvent.extend({
    name: z.literal("DemoRequest_Visit"),
    properties: z.record(z.any())
});
export const DemoRequest_Submit = BaseAnalyticsEvent.extend({
    name: z.literal("DemoRequest_Complete"),
    properties: z.record(z.any())
});
// Whenever a user signs in
export const User_SignUp = BaseAnalyticsEvent.extend({
    name: z.literal("User_SignUp")
});
// Whenever a user signs up
export const User_LogIn = BaseAnalyticsEvent.extend({
    name: z.literal("User_LogIn")
});
// Whenever a user signs out
export const User_LogOut = BaseAnalyticsEvent.extend({
    name: z.literal("User_LogOut")
});
// Whenever a user accepts an invite
export const User_AcceptInvite = BaseAnalyticsEvent.extend({
    name: z.literal("User_AcceptInvite")
});
